export enum BillingUomEnum {
  Weight = 1,
  Volume = 2,
  Units = 3
}
